import { effect, Injectable, signal } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { FolderContractObject } from '@libs/types/src/services/object-type/folder/folder-contract.object';

@Injectable()
export class WaitingListClientUpsertDialogStore extends ComponentStoreV2Factory {

    public folderId = signal<number | null>(null);
    public contract = signal<FolderContractObject | null>(null);

    constructor() {
        super();

        effect(() => {
            this.folderId.set(this.data.getFolderByPerson()?.id || null);
        });

        effect(() => {
            const contracts = this.data.getFolderContracts()?.['items'] || [];

            if (contracts.length === 1) {
                this.contract.set(contracts[0]);
            }
        });
    }
}
